import { useQuery } from '@tanstack/react-query'
import { useAppContext } from '../../../../../redux/slices/appContext'
import { postNamedQuery } from '../../../../../service'
import { QUERY_KEYS } from '../../../../../api/queryKeys'
import { useSeCodes } from './SeDebugContext'

export default function useSfClientTasks () {
  const { clientId } = useAppContext()
  const codes = useSeCodes()

  const query = useQuery({
    queryKey: [QUERY_KEYS.woSfTasks, clientId, codes.list],
    queryFn: async () => {
      const { data } = await postNamedQuery('coreData', 'invoke-smart-endpoint', {
        pipelineCode: codes.list,
        variables: { clientId }
      })
      return data
    },
    enabled: !!clientId
  })

  const tasks = query.data?.tasks ?? []
  const notLinked = query.data?.notLinked === true

  return {
    tasks,
    notLinked,
    isLoading: query.isLoading,
    error: query.error
  }
}
